import { c as _c } from "react/compiler-runtime";
import { Button, LayoutModal } from 'design-system/client';
import { useTranslations, useLocale } from 'next-intl';
import { useCallback, useId, useState } from 'react';
import styles from './AttributionModal.module.css';
import TextLink from '@/components/TextLink';
import { RailsRoutes } from '@/helpers/utils';
function ModalContent() {
  const $ = _c(14);
  const t = useTranslations("nextjs.receiver_pages.fundraising_event");
  const locale = useLocale();
  let t0;
  if ($[0] !== t) {
    t0 = t("donation_attribution_modal_content");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <p>{t0}</p>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== locale) {
    t2 = RailsRoutes.aboutUs({
      locale
    });
    $[4] = locale;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("donation_attribution_modal_read_more_button");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <TextLink external={true} href={t2}>{t3}</TextLink>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t4) {
    t5 = <div>{t1}{t4}</div>;
    $[11] = t1;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function AttributionModal(t0) {
  const $ = _c(28);
  const {
    id: id_
  } = t0;
  const t = useTranslations("nextjs");
  const [open, setOpen] = useState(false);
  const generatedId = useId();
  const id = id_ || `donation-attribution-modal-${generatedId}`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpen(_temp);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggleModalOpen = t1;
  let t2;
  if ($[1] !== t) {
    t2 = t("receiver_pages.fundraising_event.donation_attribution_start");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${id}-trigger`;
  let t4;
  if ($[3] !== t) {
    t4 = t("receiver_pages.fundraising_event.donation_attribution_modal_trigger");
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <Button kind="plain" size="small" onClick={toggleModalOpen} id={t3}>{t4}</Button>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("receiver_pages.fundraising_event.donation_attribution_end");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t5 || $[12] !== t6) {
    t7 = <div className={styles.donationAttribution}>{t2}{t5}{t6}</div>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("receiver_pages.fundraising_event.donation_attribution_modal_headline");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("core.close");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      contentContainer: styles.modal
    };
    t11 = <ModalContent />;
    $[18] = t10;
    $[19] = t11;
  } else {
    t10 = $[18];
    t11 = $[19];
  }
  let t12;
  if ($[20] !== id || $[21] !== open || $[22] !== t8 || $[23] !== t9) {
    t12 = <LayoutModal id={id} isOpen={open} title={t8} onClose={toggleModalOpen} closeText={t9} classNames={t10}>{t11}</LayoutModal>;
    $[20] = id;
    $[21] = open;
    $[22] = t8;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t7) {
    t13 = <>{t7}{t12}</>;
    $[25] = t12;
    $[26] = t7;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}
function _temp(prevState) {
  return !prevState;
}
export default AttributionModal;